var PageContent = {
    checkInputs: function() {
        let page = $('#page').val().length;
        let content = $('#content').val().length;
        let uid = $('#uid').val().length;
        if (page > 0 && content > 0 && uid > 0) {
            return true;
        } else {
            return false;
        }
    },
    editPageContent: function() {
        this.editPageContentPromise()
            .then((response) => {
                //$('#message').html('<a href="/' + $('#page').val() + '" class="underline">' + $('#title').val() + ' page</a> content updated');
                window.location.pathname = "/" + $('#page').val();
            })
            .catch((error) => {
                console.log(error);
            });
    },
    editPageContentPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.page = $('#page').val();
            request.content = $('#content').val();
            request.uid = $('#uid').val();
            window.axios.post('/admin/page-content', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

$(document).ready(function() {
    // click edit page content
    $('#editPageContent').on('click', function() {
        // check inputs
        if (!PageContent.checkInputs())
            return;
        PageContent.editPageContent();
    });
});